import { BRAND } from '../api';

export const roleLocalizationConfig = [
  'koor',
  'lirv',
  'lrma',
  'ownbt',
  'alfwn',
];


export const hasRoleLocalization = (): boolean => {
  return roleLocalizationConfig.includes(BRAND);
}

export const toLocalKey = (label: string) => {
  return (
    label
      .toLowerCase()
      .trim()
      .replace(/['",.?/|]/g, '')
      .replace(/\s+/g, '_')
      .replace(/-+/g, '_')
  );
}
